import { render, staticRenderFns } from "./Si.vue?vue&type=template&id=4a3b12ae&scoped=true&lang=html&"
import script from "./Si.vue?vue&type=script&lang=js&"
export * from "./Si.vue?vue&type=script&lang=js&"
import style0 from "./Si.vue?vue&type=style&index=0&id=4a3b12ae&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b12ae",
  null
  
)

export default component.exports